import type { NotificationType } from '~/interfaces/notification';

import Button from '../Button';
import useReadNotifications from './hooks/useReadNotifications';

interface Props {
  notifications: NotificationType[];
}

const MarkAllAsRead = ({ notifications }: Props) => {
  const { handleReadAllNotifications } = useReadNotifications();

  return (
    <div className="flex w-full justify-center px-4 pt-4">
      <Button
        type="button"
        variant="ghost"
        className="flex w-full justify-center"
        btnSize="sm"
        onClick={() => handleReadAllNotifications(notifications)}
      >
        Mark all as read
      </Button>
    </div>
  );
};

export default MarkAllAsRead;
